export default "__VITE_PUBLIC_ASSET__3107e52b__"